<div style="max-width: 70%" [style.width]="width+'px'">

  <mat-card class="flex-inline">
    @if (filterFields?.length > 0) {
      <button mat-button class="sticky-header bg-accent-50 filter-button" (click)="drawerFilter.toggle()"
              color="primary">
        <div class="flex align-item-center">
          @if (isLoading) {
            <i class="ti ti-loader f-18 m-r-10"></i>
            Cargando datos ...
          } @else {
            <i class="ti ti-filter f-18 m-r-10"></i>
            @switch (filterCount) {
              @case (0) {
                Filtrar
              }
              @case (1) {
                1 Filtro aplicado
              }
              @default {
                {{ filterCount }} Filtros aplicados
              }
            } | {{ countFindElements }} {{ countFindElements === 1 ? 'elemento' : 'elementos' }}
          }
        </div>
      </button>
    } @else {
      <button mat-button class="sticky-header bg-accent-50 filter-button" color="primary">
        <div class="flex align-item-center">
          @if (isLoading) {
            <i class="ti ti-loader f-18 m-r-10"></i>
            Cargando datos ...
          } @else {
            {{ countFindElements }} {{ countFindElements === 1 ? 'elemento' : 'elementos' }}
          }
        </div>
      </button>
    }

    <ul class="list-group list-group-flush card-list-group">
      @for (element of elements; track element; let index = $index) {
        <li class="list-group-item my-task p-5" [class.item-is-select]="selectedIds.has(element._id)">

          <div class="flex align-item-center " (ngxVisibility)="onVisible(element, $event, index)">
            <div class="flex-shrink-0"
                 style="margin-right: 5px; margin-left: -15px; z-index: 99"
                 (click)="toggleSelect(element)"
            >
              @if (selectedIds.has(element._id)) {
                <i class="ti task-icon ti-check f-22 bg-accent-500 "></i>
              } @else {
                <i class="ti task-icon ti-circle f-22 bg-accent-500 color-transparent show-hover"></i>
              }
            </div>

            <div class="flex-shrink-0 m-r-10"
                 *ngIf="( element.$update | cardImgRender:  getExtraData(element): structure)"
                 (click)="onlySelect(element)" (dblclick)="onDoubleClick(element)">
              <img
                [src]="( element.$update | cardImgRender:  getExtraData(element): structure)"
                alt="user-image"
                class="user-avtar wid-50 hie-50 b-rad-10" />
            </div>

            <div class="flex-grow-1 p-2" (click)="onlySelect(element)" (dblclick)="onDoubleClick(element)">
              <div class="f-w-500">
                <label
                  [innerHTML]="element.$update | cardTitleRender:  getExtraData(element): structure">
                </label>
              </div>
              @for (body of (element.$update | cardBodyRender: getExtraData(element): structure); track body) {
                @if (body.type === 'ago') {
                  <label> {{ body.value }}</label>
                } @else if (body.type === 'html') {
                  <label [innerHtml]="body.value"></label>
                } @else if (body.type === 'time-real') {
                  <app-duration-text [dateValue]="body.value" />
                } @else {
                  <label> {{ body.value }}</label>
                }
              }
            </div>

            <div class="flex-shrink-0 content-actions">
              @for (action of actionsInRow; track action) {
                <i
                  class="item-action ti f-22 {{element.$update | cardIconRender: action: getExtraData(element)}}"
                  (click)="pressAction(action.key, [element])"
                ></i>
              }
            </div>

          </div>
        </li>
      }
    </ul>
  </mat-card>
  <div>
    @if (isLoading && Array.isArray(sources)) {
      <button
        mat-raised-button
        color="primary"
        class="b-rad-20 indicative-loading"
      >
        <div class="flex align-item-center">
          <i class="ti ti-loader f-18 m-r-10"></i>
          Cargando datos ...
        </div>
      </button>
    }
  </div>
</div>

<mat-drawer #drawerFilter position="end" class="notification-status sidenav" style="z-index: 99999" >
  <div class="drawer-header">
    <div class="f-16 f-w-600">Filtros</div>
    <button type="button" mat-icon-button class="close-drawer" (click)="drawerFilter.toggle()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <ng-scrollbar visibility="hover">
    @if(filterFields){
      <app-filter-data-set [fields]="filterFields" [valueRecord]="filterValueRecord" (valueRecordChange)="onChangeFilterValues($event)" />
    }
  </ng-scrollbar>
</mat-drawer>

